import { AppI18NLanguageInfo } from '@inway/layout';
import { InitOptions } from 'i18next';

export const fallbackLng = 'en';
export const defaultNS = 'translation';

export const cookieName = 'i18n_language';

export const languages: Record<string, AppI18NLanguageInfo> = {
  en: {
    code: 'en',
    name: 'English',
    nativeName: 'English',
  },
  pl: {
    code: 'pl',
    name: 'Polish',
    nativeName: 'Polski',
  },
};

export function getOptions(
  lng: string = fallbackLng,
  ns: string = defaultNS
): InitOptions {
  return {
    debug: !true,
    supportedLngs: Object.keys(languages),
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns: ['translation', 'validation', 'zxcvbn'],
  };
}
